var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessionalServicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.314 165C136.212 165 165.314 135.899 165.314 100C165.314 64.1015 136.212 35 100.314 35C64.4153 35 35.3138 64.1015 35.3138 100C35.3138 135.899 64.4153 165 100.314 165Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.219 49H39.4087C36.5919 49 34.3138 51.4024 34.3138 54.3719V143H169.314V54.3719C169.314 51.4024 167.036 49 164.219 49Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3138 138V54.0861C34.3138 51.2742 36.5919 49 39.4087 49H164.219C167.036 49 169.314 51.2742 169.314 54.0861V138",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.215 54H44.4125C41.5965 54 39.3138 56.2816 39.3138 59.0961V126.904C39.3138 129.718 41.5965 132 44.4125 132H158.215C161.031 132 163.314 129.718 163.314 126.904V59.0961C163.314 56.2816 161.031 54 158.215 54Z",
    fill: "#ECEEF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.314 138H118.154L115.606 140.6H85.022L82.4734 138H21.3138V143.2C21.3138 147.486 24.7508 151 28.9596 151H171.668C175.891 151 179.314 147.509 179.314 143.2V138Z",
    fill: "#FF5000",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8439 61.9594H53.7105L53.7172 61.9661C51.5772 61.9661 49.8372 63.6994 49.8372 65.8461V100.999C49.8372 103.139 51.5705 104.879 53.7172 104.879H65.2776V113.046C65.2776 118.013 69.3042 122.04 74.2711 122.04H145.551C150.518 122.04 154.544 118.013 154.544 113.046V81.2529C154.544 76.286 150.518 72.2596 145.551 72.2596H89.1231C88.098 66.4061 82.9916 61.9594 76.8439 61.9594Z",
    fill: "#AEAEAE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.797 69.0262H70.5172C65.5503 69.0262 61.5237 73.0526 61.5237 78.0195V109.813C61.5237 114.78 65.5503 118.806 70.5172 118.806H141.797C146.764 118.806 150.79 114.78 150.79 109.813V78.0195C150.79 73.0526 146.764 69.0262 141.797 69.0262Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.804 69.0262H61.5237V111.8C61.5237 115.673 64.6638 118.813 68.5371 118.813H142.224C146.957 118.813 150.79 114.98 150.79 110.246V78.0195",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.05 110.22H143.503",
    stroke: "#FF5000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4573 89.626H100.044",
    stroke: "#FF5000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4573 81.0395H113.777",
    stroke: "#FF5000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.357 110.22H118.17",
    stroke: "#FF5000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1137 58.9391H79.1945C86.0654 58.9391 91.6327 64.5064 91.6327 71.3774V110.322C91.6327 105.593 87.8015 101.761 83.0722 101.761H56.1204C53.9786 101.761 52.2492 100.025 52.2492 97.8902V62.8169C52.2492 60.6751 53.9786 58.9391 56.1137 58.9391Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 1.49659,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9665 118.806C87.6536 118.806 91.4507 115.009 91.4507 110.322",
    stroke: "#4D4D4D",
    strokeWidth: 1.48326,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.446 73.7666L115.093 104.119L103.665 109.015L108.561 97.5871L138.914 67.2344C140.188 65.9596 142.256 65.9596 143.531 67.2344L145.446 69.1497C146.721 70.4244 146.721 72.4919 145.446 73.7666Z",
    fill: "#FF5000",
    stroke: "#4D4D4D",
    strokeWidth: 1.42695,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.852 66.5624L146.118 63.2963C147.019 62.3957 148.484 62.3957 149.384 63.2963C150.285 64.1968 150.285 65.6618 149.384 66.5624L146.118 69.8285",
    fill: "#FF5000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M142.852 66.5624L146.118 63.2963C147.019 62.3957 148.484 62.3957 149.384 63.2963C150.285 64.1968 150.285 65.6618 149.384 66.5624L146.118 69.8285",
    stroke: "#4D4D4D",
    strokeWidth: 1.42695,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.319 69.8284L142.852 76.3606",
    stroke: "#4D4D4D",
    strokeWidth: 1.42695,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M110.197 95.951L116.729 102.483",
    stroke: "#4D4D4D",
    strokeWidth: 1.42695,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalServicesIcon);
export default __webpack_public_path__ + "static/media/professional-services-icon.7d3b02a7537c9ab46388084da94e7055.svg";
export { ForwardRef as ReactComponent };